export default "__VITE_ASSET__BJ9spSd5__"